import { createFileRoute } from '@tanstack/react-router';
import { RequestsPage } from '@/features/purchasing/RequestsWorkspace';
export const Route = createFileRoute('/_dashboard/dashboard/purchasing/requests')({
  component: Page,
});
function Page() {
  const { jobId } = Route.useSearch();
  return <RequestsPage jobId={jobId} />;
}
